import * as React from 'react';
import Popover from '@mui/material/Popover';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import Slider from '@mui/material/Slider';
import Stack from '@mui/material/Stack';
import PropTypes from 'prop-types';
import useTimeStore from '../ZustandProvider';

const BasicPopover = props => {
  const { id } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const layersTrans = useTimeStore(state => state.layersTrans);
  const setLayersTrans = useTimeStore(state => state.setLayersTrans);
  const indice = layersTrans.findIndex(x => x.id === id);
  const inicialValue = indice < 0 ? 0.8 : layersTrans[indice].value;
  const [value, setValue] = React.useState(inicialValue);

  const handleSliderChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    if (inicialValue !== value) {
      const index = layersTrans.findIndex(x => x.id === id);
      const stylesAlpha = layersTrans[index];
      stylesAlpha.value = value;
      const B = layersTrans;
      B[index] = stylesAlpha;
      setLayersTrans([...B]);
      setAnchorEl(null);
    } else {
      setAnchorEl(null);
    }
  };

  const open = Boolean(anchorEl);
  const id2 = open ? 'simple-popover' : undefined;

  return (
    <div>
      <IconButton aria-describedby={id2} variant="contained" onClick={handleClick}>
        <EditIcon />
      </IconButton>
      <Popover
        id={id2}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Box
          sx={{
            width: '125px',
            marginRight: '16px',
            marginLeft: '16px',
            marginTop: '8px'
          }}
        >
          <Stack spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
            <Slider
              aria-label="Temperature"
              defaultValue={inicialValue}
              onChange={handleSliderChange}
              color="secondary"
              step={0.01}
              min={0}
              max={1}
            />
          </Stack>
        </Box>
      </Popover>
    </div>
  );
};
BasicPopover.defaultProps = {
  id: ''
};
BasicPopover.propTypes = {
  id: PropTypes.string
};
export default BasicPopover;
